<template>
  <div class="card" :class="classObject">
    <video v-if="image && isVideo" class="card-img-top" controls>
      <source :src="image" :type="videoMimeType" />
      Seu navegador não suporta o elemento de vídeo.
    </video>
    <audio v-else-if="image && isAudio" class="card-audio" controls>
      <source :src="image" :type="audioMimeType" />
      Seu navegador não suporta o elemento de áudio.
    </audio>
    <div v-else-if="image && isPdf" class="pdf-preview">
      <i class="fas fa-file-pdf pdf-icon"></i>
      <span class="pdf-name">{{ pdfName }}</span>
      <a :href="image" target="_blank" class="pdf-link">Visualizar PDF</a>
    </div>
    <img v-else-if="image" class="card-img-top" :src="image" />
    <div v-if="$slots.header" class="card-header">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <div v-if="title">{{ title }}</div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardComponent',
  components: {},
  props: {
    image: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'primary',
      validator(value, props) {
        return ['primary', 'secondary', 'tertiary'].includes(value);
      },
    },
    borderVariant: {
      type: String,
      default: '',
      validator(value, props) {
        return ['', 'info'].includes(value);
      },
    },
    isBlock: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    classObject() {
      let border = '';
      if (this.borderVariant) {
        border = `border-${this.borderVariant}`;
      }
      return [border, this.variant, this.class];
    },
    isVideo() {
      if (!this.image) return false;
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.avi', '.mov', '.wmv', '.flv', '.mkv', '.mpeg', '.m4v', '.h263'];
      const extension = this.image.toLowerCase().substring(this.image.lastIndexOf('.'));
      return videoExtensions.includes(extension);
    },
    isAudio() {
      if (!this.image) return false;
      const audioExtensions = ['.mp3', '.aac', '.mpeg', '.mpg', '.mp4-latm', '.3gpp'];
      const extension = this.image.toLowerCase().substring(this.image.lastIndexOf('.'));
      // Verifica se é .ogg mas não é vídeo, ou se é uma extensão de áudio
      return audioExtensions.includes(extension) || (extension === '.ogg' && !this.isVideo) || (extension === '.mp4' && this.image.includes('audio'));
    },
    isPdf() {
      if (!this.image) return false;
      const extension = this.image.toLowerCase().substring(this.image.lastIndexOf('.'));
      return extension === '.pdf';
    },
    pdfName() {
      if (!this.isPdf) return '';
      const fileName = this.image.split('/').pop();
      return fileName || 'Documento PDF';
    },
    videoMimeType() {
      if (!this.isVideo) return '';
      const extension = this.image.toLowerCase().substring(this.image.lastIndexOf('.'));
      const mimeTypes = {
        '.mp4': 'video/mp4',
        '.webm': 'video/webm',
        '.ogg': 'video/ogg',
        '.avi': 'video/x-msvideo',
        '.mov': 'video/quicktime',
        '.wmv': 'video/x-ms-wmv',
        '.flv': 'video/x-flv',
        '.mkv': 'video/x-matroska',
        '.mpeg': 'video/mpeg',
        '.m4v': 'video/mp4',
        '.h263': 'video/h263',
      };
      return mimeTypes[extension] || 'video/mp4';
    },
    audioMimeType() {
      if (!this.isAudio) return '';
      const extension = this.image.toLowerCase().substring(this.image.lastIndexOf('.'));
      const mimeTypes = {
        '.mp3': 'audio/mp3',
        '.aac': 'audio/aac',
        '.ogg': 'audio/ogg',
        '.mpeg': 'audio/mpeg',
        '.mpg': 'audio/mpeg',
        '.mp4': 'audio/mp4',
        '.mp4-latm': 'audio/mp4-latm',
        '.3gpp': 'audio/3gpp',
      };
      return mimeTypes[extension] || 'audio/mp3';
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.card {
  &.tertiary {
    box-shadow: none;

    .card-header {
      border-bottom: 3px solid rgba(107, 35, 220, 0.2);
    }
  }

  .card-header {
    font-size: 20px;
    font-weight: 700;
    padding-top: 0;

    .actions.top-right {
      top: 0;

      > li {
        vertical-align: bottom;
      }
    }
  }

  .card-img-top,
  .card-audio {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .pdf-preview {
    padding: 20px;
    text-align: center;
    background: #f8f9fa;

    .pdf-icon {
      font-size: 48px;
      color: #dc3545;
      margin-bottom: 10px;
    }

    .pdf-name {
      display: block;
      font-weight: bold;
      margin-bottom: 10px;
      color: #333;
    }

    .pdf-link {
      display: inline-block;
      padding: 8px 16px;
      background: #007bff;
      color: white;
      text-decoration: none;
      border-radius: 4px;
      transition: background 0.3s;

      &:hover {
        background: #0056b3;
        color: white;
        text-decoration: none;
      }
    }
  }
}
</style>
